import { render, staticRenderFns } from "./plugin-message-module-icon.vue?vue&type=template&id=5496a608&"
import script from "./plugin-message-module-icon.vue?vue&type=script&lang=js&"
export * from "./plugin-message-module-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports